export default {"src":"/pro/_next/static/media/wld.6d694fc9.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};